/**
 * Passwortregeln (1:1 zur Web-App): ≥8 Zeichen, ≥1 Zahl, ≥1 Sonderzeichen.
 */
export interface PwRule {
  key: "len" | "num" | "sym";
  label: string;
  test: (v: string) => boolean;
}

export const PW_RULES: PwRule[] = [
  { key: "len", label: "Mindestens 8 Zeichen", test: (v) => v.length >= 8 },
  { key: "num", label: "Mindestens eine Zahl", test: (v) => /\d/.test(v) },
  {
    key: "sym",
    label: "Mindestens ein Sonderzeichen (z. B. ! ? # %)",
    test: (v) => /[^A-Za-z0-9]/.test(v),
  },
];

export function passwordValid(v: string): boolean {
  return PW_RULES.every((r) => r.test(v));
}
